import { DrivingPage } from './driving/DrivingPage'
import { WalletPage } from './wallet/WalletPage'

/**
 * `manager-driving` — §9.6's driving surface, where the retired Expo app's work now happens.
 *
 * **A justified EXTRA in the parity diff.** Legacy has no `/driving` route; `route-diff.test.ts` requires
 * every extra to cite the upgrade it implements, and this one cites §9.6.
 *
 * The spec — including the web-capability mapping §9.6 asks be written *before* building — is
 * `docs/pages/manager-driving/driving-surface.md`. What that reading turned up is FB-180: legacy's
 * `driver.tsx` filtered drivers on a column that does not exist, matched orders on the wrong one, and had
 * no authentication at all. Its layout is ported; none of its wiring is.
 *
 * The guard mirrors the endpoints. `my-deliveries`, `my-availability` and `my-vehicle` are each
 * `@RequireAuth({"driver", "main_admin", "admin"})`, so an administrator may open it and sees their own —
 * empty — board, which is exactly what the server would give them.
 */
export const managerDrivingModule = {
  name: 'manager-driving',
  routes: [
    {
      path: '/driving',
      page: 'driving',
      // Behind the auth gate, outside the chrome — §9.6 asks for fullscreen and phone-first, and a sidebar
      // on a phone in a driver's hand is neither.
      fullscreen: true,
      // §9.112 — the `driver` **permission**, not a role list. The owner's point 19 is that who gets
      // the driver app is set on the account: *"ja nastavím účtom čo sú rozvozári, že zobrazovať v
      // právach"*. It also keeps this route and its new nav entry guarded identically, which
      // `agos-nav.test.ts` requires so the sidebar can never offer what the router refuses. A
      // main_admin holds every permission, so nobody who could open it before loses it.
      guard: { permission: 'driver', orSystemRoles: ['driver'] },
      component: DrivingPage,
    },
    {
      // §9.6's second surface: what I took, and what of it I hand over. Same guard as the wallet
      // endpoint, same fullscreen phone-first shape as the board it links back to.
      path: '/wallet',
      page: 'wallet',
      fullscreen: true,
      // FB-001: admit whoever the server lets read. `my-wallet` is
      // `@RequireAuth({"waiter","driver","main_admin","admin","cook"})` and its join is
      // `employee_id` for everyone who is not a driver — 2 813 orders, 48 504,22 €, all of waiters.
      // A wallet is not a driver-only thing, and guarding it as one would hide a waitress's own money
      // from her while the endpoint answered it happily.
      guard: { systemRoles: ['waiter', 'driver', 'main_admin', 'admin', 'cook'] },
      component: WalletPage,
    },
  ],
} as const

export { DrivingPage, WalletPage }
